<template>
      
    <echarts
      :key="chartId"
      :containerId="chartId"
      :options="options"
      :refreshToken="chartId"
      :type="type"
    >
    </echarts>

</template>

<script>
// eslint-disable-next-line
import Echarts from '@/components/Echarts'
// eslint-disable-next-line
import echarts from 'echarts'


export default {
  name: 'GraphLine',
  components: {
    Echarts
  },
  props: {
    type: String,
  },
  data () {
    let chartId = 'Graph-' + Math.random().toString(36).substring(2, 15)
    let options = []
    let tlTree = {}
    let years = []
    return {
      chartId,
      options,
      tlTree,
      years
    }
  },
  methods: {
    onlyUnique: function (value, index, self) { 
      return self.indexOf(value) === index;
    },

    prepareData: function () {
      let tu = this.$store.getters.TU
      let tl = this.$store.getters.TL.replace("TL", "")
      let allyears = this.$store.getters.years.sort()
      let years = allyears.filter( this.onlyUnique );

      this.years = []
      let ds = this.$store.getters.ds
      for (let y of years) {
          let year = y.toString()
          let ds_data = null
          let value = ''
          if (tl === "FUA") {
            // ds_data = ds.Data({METRO_ID: tu.toString(), TIME_PERIOD: year})
            value = ds.dataset[year][tu]
          }
          else if(tl === "EFUA" || tl === "CY"  || tl === "2" || tl === "3" ){
            value = ds.dataset[year][tu]
          }          
          else{
            ds_data = ds.Data({REG_ID: tu, TIME: year})
          }
          if (ds_data){
            value = ds_data.value
            }
          if (value !== undefined && value !== null) {
            this.years.push(year)
            this.tlTree[year] = value
          }
      }
    },

  loadGraph: function () {
      var data = []
      for (const y in this.tlTree) {
        if (this.tlTree[y]){
          data.push(this.tlTree[y])
          }
        }
      let pieces = []
      for (var v in this.$store.getters.legendThresholds) {
        pieces.push({
                lte: this.$store.getters.legendThresholds[Number(v)+1],
                color: this.$store.getters.legendColors[v]
            })
      }

      let option = {
        tooltip: {
            position: 'top',
            trigger: 'axis'
        },        
        grid: {
          top:    10,
          bottom: 0,
          left:   '0%',
          right:  '5%',
          heigth: '100%',
          containLabel: true,
        },  
        visualMap: {
            show:false,
            top: 10,
            right: 10,
            pieces: pieces,
            outOfRange: {
                color: '#000'
            }
        },
        xAxis: {
            type: 'category',
            boundaryGap: false, 
            data: this.years,
        },
        yAxis: {
            type: 'value',
            min: Math.max.apply(Math, data),
            max: Math.min.apply(Math, data),
            axisLabel: {
                formatter: (function(value){
                  let label;
                  if (value >= 1000000){ 
                    label = (value / 1000000).toFixed(2) + ' M'
                  }
                  else {
                    label = value
                  }
                  return label;
                 }),
                },            
        },
        series: [{
            data: data,
            type: 'line'
        }]
      }
    this.options = option
    }
  },
  beforeDestroy () {  
    this.$root.$off('component_refresh', () => {}) 
      delete this.chartId
      delete this.options
      delete this.tlTree
      delete this.years    
  },
  mounted () {
      // this.$root.$on('change_graph_line_data', () => {
      this.$root.$on('component_refresh', () => {         
      this.prepareData()
      this.loadGraph()
    }),

    this.prepareData()
    this.loadGraph()
  }
}
</script>
